import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import ConceptoRedocumentacion from './ConceptoRedocumentacion';
import ACCESS from '../../../ACCESS.js';

class ConceptosRedocumentacion extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'redocumentacion-concepto/filter', deleteUrl: 'redocumentacion-concepto/delete', deleteField: 'redocumentacion_concepto_nombre', modUrl: '/Catalogo/Redocumentacion' },
      TableOp.Table('Conceptos de Redocumentacion', [
        { label: 'Clave', id: 'redocumentacion_concepto' },
        { label: 'Descripcion', id: 'redocumentacion_concepto_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CONCEPTOS_DE_REDOCUMENTACION.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CONCEPTOS_DE_REDOCUMENTACION.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <ConceptoRedocumentacion  onSave={() => {this.table()}}></ConceptoRedocumentacion>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(ConceptosRedocumentacion)